/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: top;
  font-size: calc(14rem/14);
  margin: calc(13rem /14) 0 calc(4rem /14) 0;
}

.container {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
}

.label {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: absolute;
  transform: translate(0, -80%);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  left: calc(10rem/14);
  padding: 0 calc(5rem/14);
  font-size: calc(12rem/14);
  top: 1px;
  line-height: calc(18rem /14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 22rem/14);
  white-space: nowrap;
  pointer-events: none;
  /*:host([readonly]) :not(.focus).valueIsBlank & {
    background-image: linear-gradient( White, color-background-2);
  }*/
}
:host([warning]) .label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}
:host([error]) .label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}
:not(.focus):not(.hasPlaceholder).valueIsBlank .label {
  top: calc(12rem/14);
  transform: none;
  background-color: unset;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  font-size: 1rem;
  font-weight: normal;
}
:host([disabled]) .label, :host([readonly]) .label, :host([disabled]) :not(.focus):not(.hasPlaceholder).valueIsBlank .label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

.placeholder {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  top: calc(12rem/14);
  left: calc(10rem/14);
  padding: 0 calc(6rem/14);
  font-size: 100%;
  font-weight: normal;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  overflow: hidden;
  text-overflow: ellipsis;
  bottom: 1px;
  width: calc(100% - 22rem/14);
  pointer-events: none;
  white-space: nowrap;
  display: none;
}
:host([disabled]) .placeholder {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
.hasPlaceholder.showPlaceholder .placeholder {
  display: block;
}

div.focus .label {
  color: var(--davinci-color-primary,#007CC1) !important;
}
div.focus textarea {
  border: 1px solid var(--davinci-color-primary,#007CC1) !important;
}

textarea:focus {
  outline: none;
}

textarea {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  border-radius: 0;
  -webkit-appearance: none;
  border: 1px solid var(--davinci-color-outline,#8E989D);
  padding: calc(12rem/14) calc(16rem/14);
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  width: 100%;
  height: 100%;
  resize: none;
  overflow: auto;
  pointer-events: all;
}
:host([disabled]) textarea {
  border: 1px solid var(--davinci-color-outline-disabled,);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([readonly]) textarea {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([warning]) textarea {
  border: 1px solid var(--davinci-color-warning,#F5C413);
}
:host([error]) textarea {
  border: 1px solid var(--davinci-color-error,#EA0823);
}

textarea::-webkit-scrollbar {
  width: calc(18rem/14);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-input, #FFFFFF);
}

textarea::-webkit-scrollbar-thumb {
  border: calc(6rem/14) solid transparent;
  background-clip: padding-box;
  border-radius: calc(10rem/14);
  background-color: #B1B8BC;
  background-color: var(--davinci-color-text-disabled, #B1B8BC);
}

textarea::-webkit-scrollbar-thumb:hover {
  background-color: #737F85;
  background-color: var(--davinci-color-text-lighter, #737F85);
}

textarea {
  scrollbar-color: var(--davinci-color-text-disabled,#B1B8BC) var(--davinci-color-white,);
  scrollbar-width: thin;
}

:host([noresize]) textarea {
  resize: none;
}
:host([noresize]) svg {
  display: none;
}

:host([multiline]) {
  min-height: calc(120rem/14);
}

:host([hidden]) {
  display: none;
}`;
export { style };
